import React from 'react'
import { Link } from 'react-router-dom'

function Frescocombi() {
    return (
        <div className=' font-thin'>
              <div className="w-full px-6 md:px-16  mx-auto  max-w-7xl">
    
    {/* ✅ Breadcrumb Navigation */}
    <div className="flex justify-start text-sm md:text-base">
           <Link to="/" className="block py-1 pl-4 hover:underline  mt-6">Home -</Link>
           <Link to="/mainhomemodel" className="block py-1 pl-4 hover:underline mt-6">Typologies -</Link>
           <Link to="/semiverticals" className="block py-1 pl-4 hover:underline mt-6">Semi Verticals -</Link>
           <span className="block py-1 pl-4 mt-6">FRESCO COMBI</span>
    
         </div>
         {/* ✅ Product Image on Top */}
         <div className="flex justify-center mb-6">
           <img src="/images/fresco.jpg" alt="Vista" className="max-w-full h-auto object-contain" />
         </div>
    
         {/* ✅ Product Title & Description */}
         <div className="text-center mb-6">
           <h1 className="text-3xl md:text-4xl uppercase mb-8">FRESCO COMBI</h1>
           <p className="text-xl lg:text-2xl font-thin max-w-sm mx-auto text-gray-500">Assisted service and self-service, all-in-one display unit.</p>
           <p className="text-xl lg:text-2xl font-thin opacity-80 max-w-7xl mx-auto text-gray-500 mt-10">2-in-1 display unit that doubles the display area in a small footprint space. Combining two refrigerated or refrigerated and heated compartments it allows the sale of self-service and assisted service products in a single cabinet.</p>
         </div>
    
         {/* ✅ Models & Model Values */}
    <h2 className="text-3xl font-thin opacity-80 text-gray-500 mb-8 text-center ">Assisted service/self-service combi models for</h2>
    
    <div className="grid grid-cols-1 gap-4 text-center mb-6">

       <p className="text-xl lg:text-2xl opacity-90">Refrigerated Food and Beverages <span className=' text-blue-500'> -1… +5 °C</span> (3M1)</p>
       <p className="text-xl lg:text-2xl opacity-90">Hot Food and Beverages <span className=' text-red-600'> +65 °C</span></p>

    </div>

         {/* ✅ Refrigeration */}
         <div>
           <h2 className="text-3xl font-thin text-center mt-10 text-gray-500 ">Refrigeration</h2>
           <p className="text-xl lg:text-2xl text-lime-500 text-center mt-6">R290</p>

         </div>

         {/* ✅ Case Images & Features */}
         <div className="flex flex-col gap-8 md:pt-12">
            {/* case 1 */}
             <div 
               className="flex flex-col  md:pb-16 md:mt-20 md:flex-row-reverse gap-6" >
                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/freesscase.gif" className="max-w-full h-auto object-contain" />
               </div>
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4">
    <p className="text-xl md:text-4xl">The display unit that doubles business opportunities</p>
    <div className='mt-6 text-xl md:text-2xl font-thin text-gray-500'>For simultaneous assisted service and self-service of refrigerated products such as sandwiches, drinks, salads, cakes, desserts... Fresco Combi is perfect for a versatile solution combining multifunction and service with a minimal footprint to maximize shop space to the most.</div>
</div>
                
             </div>
         </div>
    
    {/* card & description */}
    <div className="flex flex-wrap gap-6 justify-center mt-16">
  {[
    {
      img: "images/freesscard.jpg",
      text: "Refrigerated models with independent temperature control for each compartment for a perfect conservation.",
    },
    {
      img: "images/freesscard1.jpg",
      text: "Upper compartment with pivotant rear service doors.",
    },
    {
      img: "images/freesscard2.jpg",
      text: "Glass dome without technical elements, superior visibility.",
    },
    {
        img: "images/freesscard3.jpg",
        text: "Grab & go compartment with slow roll night blind.",
      },
  ].map((item, index) => (
    <div key={index} className="w-full sm:w-1/2 md:w-1/3 lg:w-1/5 flex flex-col items-center mb-6">
      <div>
        <img className="w-full max-w-[20rem]" src={item.img} alt="Card Image" />
      </div>
      <div className="mt-4 text-center text-xl font-thin text-gray-500 max-w-sm">
        {item.text}
      </div>
    </div>
  ))}
</div>


 {/* case 3 */}
 <div 
               className="flex flex-col  md:pb-16 md:mt-20 md:flex-row-reverse gap-6" >
                {/* ✅ Image Wrapper */}
 <div className="w-full md:w-1/2">
                 <img src="/images/freesscase1.jpg" className="max-w-full h-auto object-contain" />
               </div>
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4">
    <p className="text-xl md:text-4xl">Some like it hot, some like it cold</p>
    <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>To the refrigerated area for self-service we have added a heated section for service. The customer orders their slice of pizza or hot snack while freely choosing and taking away their drink or fresh dessert.</div>

</div>
 
             </div>
{/* card & description */}
<div className="flex flex-wrap gap-6 justify-center mt-16">
  {[
    {
      img: "images/freesscardpre.jpg",
      text: "Display unit for assisted service and self-service simultaneously.",
    },
    {
      img: "images/freesscardpre1.jpg",
      text: "Upper compartment with pivotant rear service doors.",
    },
    {
      img: "images/freesscardpre2.jpg",
      text: "Grab & go compartment with slow roll night blind.",
    },
    
  ].map((item, index) => (
    <div key={index} className="w-full sm:w-1/2 md:w-1/3 lg:w-1/5 flex flex-col items-center mb-6">
      <div>
        <img className="w-full max-w-[20rem]" src={item.img} alt="Card Image" />
      </div>
      <div className="mt-4 text-center text-xl font-thin text-gray-500 max-w-sm">
        {item.text}
      </div>
    </div>
  ))}
</div>
            
     </div>
     {/* carosel */}
    
  
        </div>
      )
    }

export default Frescocombi